module.exports = __webpack_public_path__ + "img/iconContact.76977044.png";